/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonTrxInfo = {
    TRXHA: string;
    STAT: BabylonTrxInfo.STAT;
    MSGTPLIST: Array<string>;
    BNO: string;
    TRFAMT: string;
    TRFVAL: string;
    TRXF: string;
    TRXFVAL: string;
    AG: string;
    UT: number;
    SNO: string;
    ISBTCSTKTRX: BabylonTrxInfo.ISBTCSTKTRX;
};

export namespace BabylonTrxInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum ISBTCSTKTRX {
        Y = 'Y',
        N = 'N',
    }


}

